/**
 * Wild Workouts trainings
 * TODO
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PostTraining model module.
 * @module model/PostTraining
 * @version 1.0.0
 */
class PostTraining {
    /**
     * Constructs a new <code>PostTraining</code>.
     * @alias module:model/PostTraining
     * @param notes {String} 
     * @param time {Date} 
     */
    constructor(notes, time) { 
        
        PostTraining.initialize(this, notes, time);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, notes, time) { 
        obj['notes'] = notes;
        obj['time'] = time;
    }

    /**
     * Constructs a <code>PostTraining</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PostTraining} obj Optional instance to populate.
     * @return {module:model/PostTraining} The populated <code>PostTraining</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PostTraining();

            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], 'String');
            }
            if (data.hasOwnProperty('time')) {
                obj['time'] = ApiClient.convertToType(data['time'], 'Date');
            }
        }
        return obj;
    }


}

/**
 * @member {String} notes
 */
PostTraining.prototype['notes'] = undefined;

/**
 * @member {Date} time
 */
PostTraining.prototype['time'] = undefined;






export default PostTraining;

